import type { SVGProps } from 'react';

interface HistoryIconProps {
  title?: string;
  titleId?: string;
}
export const HistoryIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & HistoryIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M12 .003A12 12 0 1 1 .05 10.913a1.333 1.333 0 0 1 2.656.24 9.28 9.28 0 0 0 2.694 7.45 9.333 9.333 0 1 0 .064-13.264l1.867.001a1.333 1.333 0 0 1 .155 2.659l-.155.008H1.995A1.333 1.333 0 0 1 .67 6.829l-.01-.156V1.34a1.333 1.333 0 0 1 2.66-.155l.007.156v2.366A11.98 11.98 0 0 1 12 .003m-1 5.333a1 1 0 0 1 .99.864l.01.136v5.667h3a1 1 0 0 1 .136 1.99l-.136.01h-4a1 1 0 0 1-.99-.864l-.01-.136V6.336a1 1 0 0 1 1-1"
      fill="currentColor"
    />
  </svg>
);
